import { render } from "./BarMenuSeparator.vue?vue&type=template&id=4ba03b66"
const script = {}

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__